import React, { useState } from 'react';
import { Button, Input, HStack } from '@chakra-ui/react';
import { trackAction } from '../../../helpers/trackAction';

interface DiplomaInputComponentProps {
  initialName: string;
  isTeacher?: boolean;
  programId?: string;
  studyGroupId?: string;
}

const DiplomaInputComponent: React.FC<DiplomaInputComponentProps> = (props) => {
  const { initialName, isTeacher, programId, studyGroupId } = props;

  const [name, setName] = useState<string>(initialName);

  const printDiploma = () => {
    let urlOptions = new URLSearchParams();
    urlOptions.set('name', name);
    if (isTeacher) {
      urlOptions.set('teacher', 'true');
    }
    if (programId) {
      urlOptions.set('program', programId);
    }
    if (studyGroupId) {
      urlOptions.set('studyGroup', studyGroupId)
    }

    trackAction({
      action_type: 'print_diploma',
      data: { name, programId, isTeacher, studyGroupId },
    });

    // window.open(
    //   `/diploma/diploma-print-view/?${urlOptions.toString()}`,
    //   undefined,
    //   'popup=true,width=1280,height=800',
    // );

    window.open(
      `/diploma/diploma-print-new-view/?${urlOptions.toString()}`,
      undefined,
      'popup=true,width=1280,height=800',
    );
  };

  return (
    <HStack spacing="8">
      <Input
        placeholder="Name"
        value={name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setName(e.target.value);
        }}
      ></Input>
      <Button minW="unset" onClick={printDiploma}>
        Print diploma
      </Button>
    </HStack>
  );
};

export default DiplomaInputComponent;
export { DiplomaInputComponent };
